import loadable from '@loadable/component';

export const SalarySurveyBannerLoadable = loadable(
  () => import('./SalarySurveyBanner'),
  { resolveComponent: (module) => module.SalarySurveyBanner },
);
